import { render, staticRenderFns } from "./google-v2.vue?vue&type=template&id=0fe08060&scoped=true&"
import script from "./google-v2.vue?vue&type=script&lang=js&"
export * from "./google-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe08060",
  null
  
)

export default component.exports